import axios from 'axios';
import React, { useState, useEffect, useCallback } from 'react';
import { useCookies } from 'react-cookie';
import { useForm } from 'react-hook-form'
import Cookies from 'universal-cookie'
import { Button, ContentsLayout, ContentsHeader, Radio } from 'src/components'
import styles from './Download.module.scss';
import fileDownload from 'js-file-download'
import { Oval } from 'react-loader-spinner'
import clsx from 'clsx'

/**
 * Import コンポーネント
 * 鳥獣害データのインポート
 * @returns React.ReactNode
 */
const Download: React.FC = () => {

  /**
   * GoogleAnalytics用トラッキング
   */
  useEffect(() => {
    window.gtag !== undefined && window.gtag('config', `${process.env.REACT_APP_DEV_TRACKING_ID}`, { page_path: window.location.pathname });
  }, []);

  /**
   * CSV取込フォーム
   */
  const { register, watch, handleSubmit, formState: { errors } } = useForm();

  /**
   * ログイン情報のCookie
   */
  const [cookie] = useCookies()

  /**
   * ログイン情報削除時に使用
   */
  const cookies = new Cookies();

  /**
   * 空CSVダウンロード
   */
  // function handleCSVDownload() {
  //   setIsDownloaded(true)
  // }

  /**
* API通信中判定フラグ
*/
  const [loading, setLoading] = useState(false);
  /**
   * ダウンロード処理
   */
  
   const handleClick = useCallback((filename:string, getname:string) => {
    setLoading(true);
    let LTI = cookie.verminData.api_token;
    let url = `${process.env.REACT_APP_DEV_URL}`+"/file/download?token="+LTI+"&fileName="+filename;
    axios.get(url, {
      responseType: 'blob',
    })
    .then((result) => {
      if (result.data) {
        fileDownload(result.data, getname);
        setIsSuccessPopup(true);
        setTimeout(() => {
          setIsSuccessPopup(false);
        }, 3000);
      } else {
        setIsErrorPopup(true);
        setTimeout(() => {
          setIsErrorPopup(false);
        }, 3000);
      }
    })
    .catch(async err => {
      //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
      if (err?.response?.data?.message === "Unauthenticated.") {
        await cookies.remove('verminData');
        await window.location.replace('/');
      }
    }).finally(() => {
      //通信完了後Loading非表示
      setLoading(false)
    });
  },[]);

  /**
   * CSV取込時のポップアップ出現フラグ
   */
  const [isErrorPopup, setIsErrorPopup] = useState(false);
  const [isSuccessPopup, setIsSuccessPopup] = useState(false);

  return (
    <span>
    {loading &&
      <div className={styles.modalWrapper}>
        <div className={styles.modalOverlay}>
          <Oval
            ariaLabel="loading-indicator"
            height={75}
            width={75}
            strokeWidthSecondary={1}
            color="#3a6468"
            secondaryColor="white"
          />
        </div>
      </div>
    }
    <ContentsLayout>
      <ContentsHeader title="ダウンロード">
      </ContentsHeader>
      <div className={clsx(styles.popup, isSuccessPopup && styles.success)}>資料のダウンロードに成功しました。
      </div>
      <div className={clsx(styles.popup, isErrorPopup && styles.error)}>資料のダウンロードにに失敗しました。再ログインを行ってください。
      </div>
        <div className={styles.dbuttonFiled}>
        <Button className={styles.dbutton} 
          onClick={() => handleClick('click_manual.pdf','獣マップ_クイックマニュアル.pdf')}>クイックマニュアル</Button>
        <Button className={styles.dbutton} 
          onClick={() => handleClick('startup_manual.pdf','獣マップ_スタートアップマニュアル.pdf')}>スタートアップマニュアル</Button>
        <Button className={styles.dbutton} 
          onClick={() => handleClick('import_template.zip','獣マップ_情報登録インポートテンプレート.zip')}>情報登録インポートテンプレート</Button>
        </div>
    </ContentsLayout >
    </span>
  );
};

export default Download;

